/* tslint:disable */
/* eslint-disable */
/**
 * resident-resources
 * resident-resources
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TaskExtensionTemplate } from './TaskExtensionTemplate';
import {
    TaskExtensionTemplateFromJSON,
    TaskExtensionTemplateFromJSONTyped,
    TaskExtensionTemplateToJSON,
} from './TaskExtensionTemplate';

/**
 * 
 * @export
 * @interface FindAllTaskExtensionTemplates200Response
 */
export interface FindAllTaskExtensionTemplates200Response {
    /**
     * 
     * @type {Array<TaskExtensionTemplate>}
     * @memberof FindAllTaskExtensionTemplates200Response
     */
    data?: Array<TaskExtensionTemplate>;
}

/**
 * Check if a given object implements the FindAllTaskExtensionTemplates200Response interface.
 */
export function instanceOfFindAllTaskExtensionTemplates200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllTaskExtensionTemplates200ResponseFromJSON(json: any): FindAllTaskExtensionTemplates200Response {
    return FindAllTaskExtensionTemplates200ResponseFromJSONTyped(json, false);
}

export function FindAllTaskExtensionTemplates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllTaskExtensionTemplates200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TaskExtensionTemplateFromJSON)),
    };
}

export function FindAllTaskExtensionTemplates200ResponseToJSON(value?: FindAllTaskExtensionTemplates200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TaskExtensionTemplateToJSON)),
    };
}

